import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LIVECROUSELOPTION, MENUS } from '@app/core';
import { IUser } from '@app/core/models';
import { SportService, UserService } from '@app/core/services';
import { CommonService } from '@app/core/services/common.service';
import { environment } from '@environments/environment';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  header = true;
  video = false;
  assetUrl = environment.assetUrl;
  menus = MENUS;
  liveOption = LIVECROUSELOPTION;
  notifications = true;
  notificationData: any;
  notificationForm: FormGroup;
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    public _user: UserService,
    public router: Router,
    public _activated: ActivatedRoute,
    public _sport: SportService,
    public _common: CommonService,
    private _builder: FormBuilder
  ) {
    this.notificationForm = this._builder.group({
      like_notify: [true],
      reply_notify: [false],
      follow_notify: [false],
    });
  }

  ngOnInit() {
    this._activated.queryParamMap.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.header = data.get('header') == 'false' ? false : true;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  redirectLogin() {
    sessionStorage.setItem(
      'return_url',
      decodeURI(this.router.routerState.snapshot.url)
    );
  }

  logout() {
    this._user.authState.next(false);
    this._user.authUser.next({} as IUser);
    localStorage.removeItem('xsrf');
    if (this._common.isBrowser) location.href = '/';
  }

  async getNotifications() {
    if (!this._user.isLoggedIn()) return;
    let user = this._user.authUser.getValue();
    this.notificationForm.get('like_notify')?.setValue(user.like_notify);
    this.notificationForm.get('follow_notify')?.setValue(user.follow_notify);
    this.notificationForm.get('reply_notify')?.setValue(user.reply_notify);
    let res = await this._user.getNotifications();
    this.notificationData = res.data;
  }

  async updateNotification() {
    let user = this._user.authUser.getValue();
    await this._user.updateNotification(user.id, this.notificationForm.value);
    user.like_notify = this.notificationForm.get('like_notify')?.value;
    user.follow_notify = this.notificationForm.get('follow_notify')?.value;
    user.reply_notify = this.notificationForm.get('reply_notify')?.value;
    this._user.authUser.next(user);
  }
}
